import {
    primaryColor,
    dangerColor,
    successColor,
    defaultFont,
    whiteColor,
    secondaryColor
  } from "@themes/defaultThemeProps";
  
  const customInputStyle = {
    disabled: {
      "&:before": {
        borderColor: "transparent !important"
      }
    },
    underline: {
      "&:hover:not($disabled):before,&:before": {
        borderColor: secondaryColor[4] + "!important",
        borderWidth: "1px !important"
      },
      "&:after": {
        borderColor: primaryColor[0]
      },
      "& + p": {
        fontWeight: "300"
      }
    },
    underlineError: {
      "&:after": {
        borderColor: dangerColor[0]
      }
    },
    underlineSuccess: {
      "&:after": {
        borderColor: successColor[0]
      }
    },
    labelRoot: {
      ...defaultFont,
      color: secondaryColor[3] + " !important",
      fontWeight: "400",
      fontSize: "10px",
      lineHeight: "0",
    },
    labelRootError: {
      color: dangerColor[0] + " !important"
    },
    labelRootSuccess: {
      color: successColor[0] + " !important"
    },
    formControl: {
      margin: "0 0 17px 0",
      paddingTop: "27px",
      position: "relative",
      verticalAlign: "unset",
      "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
        color: secondaryColor[5]
      }
    },
    whiteUnderline: {
      "&:hover:not($disabled):before,&:before": {
        backgroundColor: whiteColor
      },
      "&:after": {
        backgroundColor: whiteColor
      }
    },
    input: {
      color: secondaryColor[5],
      height: "unset",
      "&,&::placeholder": {
        fontSize: "14px",
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: "400",
        lineHeight: "1.42857",
        opacity: "1"
      },
      "&::placeholder": {
        color: secondaryColor[3]
      }
    },
    whiteInput: {
      "&,&::placeholder": {
        color: whiteColor,
        opacity: "1"
      }
    }
  };
  
  export default customInputStyle;
  